/**
 * AUTO-GENERATED AT BUILD TIME - DO NOT EDIT.
 *
 * Source: https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json
 */
// prettier-ignore
export const Q: readonly string[] = [
	"ActiveCommentsQuery",
	"ApprovalsContextApprovalsDataQuery",
	"ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"ArchivedPageBannerV2ArchivedPageBannerQuery",
	"BlogTreeRootComponentQuery",
	"CollabDraftQuery",
	"ContentBlogUnifiedQuery",
	"ContentHeaderPresenceContentSettingsQuery",
	"ContentHeaderUnifiedQuery",
	"ContentPrerequisitesQuery",
	"ContentRedirectQuery",
	"ContentTypesHeaderQuery",
	"ContentUnifiedQuery",
	"ContentUnifiedWithSpaceKeyQuery",
	"CookieConsentPreferences",
	"CoverPictureQuery",
	"CustomHeaderFooterQuery",
	"DatabaseContainerQuery",
	"EditContentButtonQuery",
	"EditorContentStateQuery",
	"EditorPreferencesQuery",
	"EmojiTitleQuery",
	"EndOfPageRecommendationQuery",
	"FollowingFeedWithSortByStorageSnippetsQuery",
	"FooterCreateButtonsQuery",
	"ForgeExtensionList",
	"GlobalNavigationComponentQuery",
	"GrantAccessDialogLoaderQuery",
	"HomeRecentWorkQuery",
	"InlineCommentsFocusedInlineCommentQuery",
	"LegacyMacroRendererQueryBodyQuery",
	"LivePagesByLineLastUpdatedQuery",
	"LocalStorageQuery",
	"NativeCollabQuery",
	"NotFoundContainerQuery",
	"NotificationsButtonQuery",
	"ObjectCommentContainerPreloadObjectCommentsQuery",
	"PageRestrictionsContextQuery",
	"PageTreeQuery",
	"PageTreeQueryWithSpaceKeyQuery",
	"PermissionCheckAddCommentQuery",
	"PersistentInviteEligibleQuery",
	"PersonalizedTemplatesV2AllTemplatesQuery",
	"PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"ReactionsContentQuery",
	"RendererContentStateQuery",
	"RestrictedPageWithCanViewQuery",
	"ScreenQuery",
	"SiteInformationQuery",
	"SmartCreateFeedbackBannerQuery",
	"SmartCreatePageEditorDataWrapperComponentQuery",
	"SpaceNavigationQuery",
	"SpaceOverviewIdQuery",
	"SpaceOverviewQuery",
	"SpaceQuery",
	"SpaceRestrictionCheckQuery",
	"ThemeQuery",
	"TopNavigationQuery",
	"UserSettingsQuery",
	"ViewSpaceExternalCollaboratorsDialogQuery",
	"WebItemLocationQuery_page.metadata.banner",
	"WebItemLocationQuery_system.content.action_system.content.button_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.action_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.byline",
	"WebItemLocationQuery_system.header_left",
	"WebItemLocationQuery_system.user",
	"WebPanelLocationQuery_atl.footer",
	"WebPanelLocationQuery_atl.general",
	"WebPanelLocationQuery_atl.general_atl.footer",
	"WebPanelLocationQuery_atl.page.content.footer.actions",
	"WebStorageCategories",
	"WelcomeMessagesQuery",
	"WhiteboardUnifiedQuery",
	"bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery",
	"bifrost-ssr/prepare/preloadQuery/editor/syncedBlocksData/fetch:SyncBlockReferences",
	"bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences",
	"contentAppearanceQuery",
	"contentSmartLinksORS",
	"fetchMentionsProviderDataQuery",
	"graphqlHelpersDSPIsActionEnabledForContentQuery",
	"graphqlHelpersFetchMediaTokenQuery",
	"loomUserPermissionQuery",
	"multiMacroQueryWithAppKeyQuery",
	"onboardingStateGetOnboardingStateQuery",
	"onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_158",
	"pageButtons",
	"preloadAutohighlightsQuery",
	"preloadContentSmartLinksQuery",
	"preloadCreateSpaceQuery",
	"preloadEditButtonWithSpaceKeyQuery",
	"preloadEditorNodeDataProvidersDataQuery",
	"preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"preloadLegacyBridgeQuery",
	"preloadOperationsQuery",
	"preloadPageStatusQueryDataQuery",
	"preloadPendingRequestExistsQuery",
	"preloadPersonalSpaceDetailsQuery",
	"preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"preloadSpaceBlogCountQuery",
	"preloadTemplatesCollectionEligibleQuery",
	"relay_ApprovalsContextApprovalsDataQuery",
	"relay_ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"relay_BlogTreeRootComponentQuery",
	"relay_CollabDraftQuery",
	"relay_ContentHeaderPresenceContentSettingsQuery",
	"relay_ContentHeaderUnifiedQuery",
	"relay_ContentTypesHeaderQuery",
	"relay_ContentUnifiedQuery",
	"relay_ContentUnifiedWithSpaceKeyQuery",
	"relay_CoverPictureQuery",
	"relay_CustomHeaderFooterQuery",
	"relay_EditContentButtonQuery",
	"relay_EditorContentStateQuery",
	"relay_EditorPreferencesQuery",
	"relay_EmojiTitleQuery",
	"relay_EndOfPageRecommendationQuery",
	"relay_FollowingFeedWithSortByStorageSnippetsQuery",
	"relay_FooterCreateButtonsQuery",
	"relay_HomeRecentWorkQuery",
	"relay_NativeCollabQuery",
	"relay_NotificationsButtonQuery",
	"relay_PageRestrictionsContextQuery",
	"relay_PageTreeQuery",
	"relay_PageTreeQueryWithSpaceKeyQuery",
	"relay_PermissionCheckAddCommentQuery",
	"relay_PersistentInviteEligibleQuery",
	"relay_PersonalizedTemplatesV2AllTemplatesQuery",
	"relay_PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"relay_ReactionsContentQuery",
	"relay_RendererContentStateQuery",
	"relay_ScreenQuery",
	"relay_SiteInformationQuery",
	"relay_SmartCreateFeedbackBannerQuery",
	"relay_SpaceNavigationQuery",
	"relay_SpaceOverviewIdQuery",
	"relay_SpaceOverviewQuery",
	"relay_SpaceOverviewSwitcherQuery",
	"relay_SpaceRestrictionCheckQuery",
	"relay_ThemeQuery",
	"relay_TopNavigationQuery",
	"relay_ViewSpaceExternalCollaboratorsDialogQuery",
	"relay_WebItemLocationQuery_page.metadata.banner",
	"relay_WebItemLocationQuery_system.header_left",
	"relay_WebPanelLocationQuery_atl.footer",
	"relay_WebPanelLocationQuery_atl.general",
	"relay_WebPanelLocationQuery_atl.page.content.footer.actions",
	"relay_WelcomeMessagesQuery",
	"relay_contentAppearanceQuery",
	"relay_fetchMentionsProviderDataQuery",
	"relay_graphqlHelpersDSPIsActionEnabledForContentQuery",
	"relay_graphqlHelpersFetchMediaTokenQuery",
	"relay_loomUserPermissionQuery",
	"relay_multiMacroQueryWithAppKeyQuery",
	"relay_onboardingStateGetOnboardingStateQuery",
	"relay_onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"relay_onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"relay_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"relay_onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"relay_onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_158",
	"relay_preloadAutohighlightsQuery",
	"relay_preloadCreateSpaceQuery",
	"relay_preloadEditButtonWithSpaceKeyQuery",
	"relay_preloadEditorNodeDataProvidersDataQuery",
	"relay_preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"relay_preloadPersonalSpaceDetailsQuery",
	"relay_preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"relay_preloadTemplatesCollectionEligibleQuery",
	"relay_shortcutsSmartLinksQuery",
	"relay_useAnalyticsByLineQuery",
	"relay_useAudioContentQuery",
	"relay_useConfluenceStandardToPremiumExperimentQuery",
	"relay_useConnectorOnboardingStateQuery",
	"relay_useContentClassificationContentDataClassificationQuery",
	"relay_useEditorContentModeValueQuery",
	"relay_useFabricEligibilityMigrationQuery",
	"relay_useFeatureDiscoveryFeatureDiscoveryQuery",
	"relay_useFeedTypeSelectorRefreshQuery",
	"relay_useGetCurrentStorageUsageQuery",
	"relay_useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"relay_useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"relay_useHomeWidgetStateQuery",
	"relay_useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"relay_useIsLoomEntryPointsEnabledQuery",
	"relay_useIsUserViewingSpaceAsAnonQuery",
	"relay_useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"relay_useLoomTenantProvisionStatusQuery",
	"relay_usePreloadCommentButtonQuery",
	"relay_useReadTimeQuery",
	"relay_useRegisterAdminAnnouncementBannerQuery",
	"relay_useShareAndRestrictButtonDataQuery",
	"relay_useSpaceBaseQueryBaseQuery",
	"relay_useSpaceDetailQuery",
	"relay_useSpaceViewsDataSpaceRootQuery",
	"relay_useSpaceViewsOptionsPersistenceQuery",
	"relay_useSpacesDataMyVisitedSpacesQuery",
	"relay_useSpacesDataStarredSpacesQuery",
	"relay_useTitleContentPropertiesForEditorQuery",
	"relay_useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"relay_useTitleContentPropertiesForPublishedPageQuery",
	"relay_useUserByLicensedProductsQuery",
	"requireSuperBatchFrontendResourceRenderQuery",
	"rightPanel",
	"searchResults",
	"shortcutsSmartLinksQuery",
	"sidenavSmartLinksORS",
	"useAnalyticsByLineQuery",
	"useAudioContentQuery",
	"useBlogPostsQueryQuery",
	"useConfluenceStandardToPremiumExperimentQuery",
	"useConnectorOnboardingStateQuery",
	"useConnectorOnboardingTeamTypeQuery",
	"useConnectorStatesQuery",
	"useContentClassificationContentDataClassificationQuery",
	"useEditorContentModeValueQuery",
	"useEmojiEverSetPropertyQuery",
	"useFabricEligibilityMigrationQuery",
	"useFeatureDiscoveryFeatureDiscoveryQuery",
	"useFeedTypeSelectorRefreshQuery",
	"useFollowingFeedWithSortByStorageFeedContentQuery",
	"useGetCurrentStorageUsageQuery",
	"useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"useHomeWidgetStateQuery",
	"useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"useIsLoomEntryPointsEnabledQuery",
	"useIsUserViewingSpaceAsAnonQuery",
	"useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"useLoomTenantProvisionStatusQuery",
	"usePageTreeSearchQueryQuery",
	"usePopularFeedWithTimeGranularityStorageQuery",
	"usePreloadCommentButtonQuery",
	"useReadTimeQuery",
	"useRegisterAdminAnnouncementBannerQuery",
	"useShareAndRestrictButtonDataQuery",
	"useShortcutsSpaceNavigationQuery",
	"useSpaceBaseQueryBaseQuery",
	"useSpaceDetailQuery",
	"useSpaceEnabledContentTypesQuery",
	"useSpaceViewsDataSpaceRootQuery",
	"useSpaceViewsOptionsPersistenceQuery",
	"useSpacesDataAnonymousSpacesQuery",
	"useSpacesDataMyVisitedSpacesQuery",
	"useSpacesDataStarredSpacesQuery",
	"useTitleContentPropertiesForEditorQuery",
	"useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"useTitleContentPropertiesForPublishedPageQuery",
	"useUserByLicensedProductsQuery"
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	"prod-apne": "deaf3d87fff5ffff2dd37fffffff02000000000000000000000000788a9ffbdee703",
	"prod-apne2": "deaf3daffff5ffff2dd37fffffff0300000000000000000000000070badf7bdee703",
	"prod-apse": "deef3dbffff5ffff2dd37fffffff02000000000000000000000000788adffbdee703",
	"prod-apse2": "deef3daffff5ffffafd37fffffff0300000000000000000000000078bbdffbdeff03",
	"prod-apsouth": "d6bf3da7fff5ffffedd37fffffff0300000000000000000000000070bbdf7bdef703",
	"prod-cacentral": "deef3db7fff7ffffafd37fffffff03000000000000000000000000709adf7fdef703",
	"prod-east": "deef3f9ffff7ffffafd37fffffff0300000000000000000000000078fadfffdeff03",
	"prod-eucentral": "deef3faf7ff5ffff2fd37fffffff0300000000000000000000000078badffbdeff03",
	"prod-eucentral2": "ceef3d82ff75ffdfa1537bffffff020000000000000000000000007088df3b9ee703",
	"prod-euwest": "deef3fbffff5ffffbfd37fffffff0300000000000000000000000078badfffdeff03",
	"prod-euwest2": "deff3dbffff7ffffafd37fffffff0300000000000000000000000070badf7bdef703",
	"prod-west2": "deef3deffff7ffffa9d37fffffff0300000000000000000000000078badfffdeef03",
	"stg-east": "f5d97d87fa778b9fadd2ffdd775fdaf1689df7f7f9e78fbefddfff7f9bdf7ebe7703"
};

export const generatedAt: string | null = "2026-07-29T03:09:02.806Z";
